<app-roster-roster-link [termCode]="termCode" [crn]="crn"></app-roster-roster-link>

<app-text [alias]="'add_student_page'"></app-text>

<app-loading-wrapper [loading]="saving || !questions">
    <form *ngIf="questions" [formGroup]="formGroup">
        <app-question [question]="questions.studentId"></app-question>
        <app-question [question]="questions.bannerFirstName"></app-question>
        <app-question [question]="questions.bannerLastName"></app-question>
        <app-question [question]="questions.emailAddress"></app-question>
        <app-question [question]="questions.gradeRule"></app-question>
        <app-button-list>
            <app-button *ngIf="newStudent" [disabled]="formGroup.invalid" [loading]="saving" (clickedEvent)="addStudent()" [icon]="'add'">Add </app-button>
            <app-button *ngIf="!newStudent" [disabled]="formGroup.invalid" [loading]="saving" (clickedEvent)="updateStudent()" [icon]="'update'">Update </app-button>
            <app-button [loading]="saving" (clickedEvent)="cancle()" [icon]="'cancel'">Cancel </app-button>
        </app-button-list>
    </form>
</app-loading-wrapper>
<div *ngIf="tempInstructorAddStudent?.length>0"  >
    <app-sortable-table *ngIf="tempInstructorAddStudent.length > 0 "
                        [data]="tempInstructorAddStudent" >
      <thead>
          <tr>
              <th></th>
              <th sortBy="sortName">Name (Last, First)</th>
              <th sortBy="studentId">Student Id</th>
              <th sortBy="enrollmentSource">Enrollment<br>Source</th>
              <th sortBy="dateLastModified">Last modified Date</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let student of tempInstructorAddStudent">
              <td>
                  <app-button-list>
                      <app-button [icon]="'edit'" (clickedEvent)="editStudent(student)"> </app-button>
                      <app-button [icon]="'delete'" (clickedEvent)="deleteStudent(student)"> </app-button>
                  </app-button-list>
              </td>
              <td><a href="mailto:{{student.emailAddress}}"> {{student.bannerLastName}}, {{student.bannerFirstName}}</a></td>
              <td>{{student.studentId}}</td>
              <td>{{student.enrollmentSource}}</td>
              <td>{{student.dateLastModified}}</td>
          </tr>
      </tbody>
    </app-sortable-table>
</div>